import React from "react";
import CustomDataGrid from "../../components/CustomDataGrid/CustomDataGrid.tsx";
import SideBar from "../../layouts/sidebar/SideBar.tsx";
import Leo from "./../../../assets/images/Leo.png";
import { Button, Grid } from "@mui/material";
import searchIcon from "./../../../assets/icons/search.ico";
import bin from "./../../../assets/icons/reject.png";
import edit from "./../../../assets/icons/edit.png";
import linkactiveImg from "./../../../assets/images/linkActive.png";
import linkDeactiveImg from "./../../../assets/images/linkDective.png";
import approveImg from "./../../../assets/icons/checked.png";
import AutoCompleteMultiSelect from "../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";
import "./NewRestaurantRequest.css";
import RestaurantDetailsDialog from "./RestaurantDetailsDialog/RestaurantDetailsDialog.tsx";
import CancelReasonDialog from "./CancelReasonDialog/CancelReasonDialog.tsx";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import loadingGif from "./../../../assets/images/loading.gif";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import LoadingView from "../../components/LoadingView/LoadingView.js";
import TopHeader from "../../../components/TopHeader.tsx";
import ediPencil from "../../../assets/icons/editPencil.png";

const getRestaurantDisplayName = (row) => {
  if (row?.businessTypeId === "Home Cook") {
    return row?.email || "";
  }
  return row?.companyLegalName || "";
};

function NewRestaurantRequest(props) {
  const columnsdatas = [
    {
      field: "companyLegalName",
      headerName: "Restaurant Name",
      renderCell: (params) => (
        <div>
          <span
            onClick={() => {
              handleClickOpen(params.row);
            }}
            style={{ color: "blue", cursor: "pointer" }}
          >
            {getRestaurantDisplayName(params.row)}
          </span>
        </div>
      ),
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "actions",
      headerName: "",
      align: "center",
      headerAlign: "center",
      width: 80,
      flex: 0.3,
      renderCell: (params) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleClickOpen(params.row)}>
          <img src={ediPencil} alt="edit" style={{ width: "18px" }} />
        </div>
      ),
    },
    {
      field: "phoneNumber",
      headerName: "Contact Number",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "address",
      headerName: "Address",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "firstName",
      headerName: "Applied by user name",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "companyRegistrationNumber",
      headerName: "Company Number",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "requestDate",
      headerName: "Request Date",
      align: "center",
      renderCell: (params) => <div>{dateFormated(params.value)}</div>,
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "approvalStatusDescription",
      headerName: "Status",
      renderCell: (params) => (
        <div
          className={`${params.value === "Approved"
              ? "approve"
              : params.value === "Pending"
                ? "pending"
                : params.value === "Link Activated"
                  ? "approve"
                  : "reject"
            } RoundedStatus`}
        >
          {params.value}
        </div>
      ),
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
  ];

  const apiAddress = process.env.REACT_APP_SECRET;

  const dateFormated = (props) => {
    var d = new Date(props);
    return d.toDateString();
  };

  const [dataRows, setDataRows] = React.useState([]);

  const [selectedData, setSelectedData] = React.useState([]);
  const [enableOptions, setEnableOptions] = React.useState(false);
  const getselectedData = (props) => {
    console.log("props: " + props);

    var temp = props;
    setSelectedData(temp);
    if (props.length > 0) {
      setEnableOptions(true);
    } else {
      setEnableOptions(false);
    }
  };
  const typrOfMenuDatas = [
    { id: 1, title: "Online" },
    { id: 2, title: "In-store" },
    // { id: 3, title: 'Cor' },
    // { id: 3, title: 'Add Type' },
  ];
  const [autoCompleteValue, setAutoCompleteValue] = React.useState([]);
  const addValue = (props) => {
    setAutoCompleteValue(props);
  };

  const [open, setOpen] = React.useState(false);
  const [clickedRestaurant, setClickedRestaurant] = React.useState("");
  const handleClickOpen = (props) => {
    var data = dataRows.find((x) => x.id === props.id);
    console.log("data: ",data);
    //console.log("dataRows: ",dataRows);
    setClickedRestaurant(data);
    setOpen(true);
  };
  const handleAddItem = (AddItemData) => {
    setOpen(AddItemData);
    loadData();
  };

  const [openCancelReasonDialog, setopenCancelReasonDialog] =
    React.useState(false);
  const [clickedRestaurantDetails, setClickedRestaurantDetails] =
    React.useState([]);
  const [allRestaurantDetails, setAllRestaurantDetails] = React.useState([]);
  const handleClickopenCancelReasonDialog = () => {
    setopenCancelReasonDialog(true);
    var tempData = [];
    var allTempData = [];
    selectedData.map((data, index) => {
      var dt = dataRows.find((x) => x.id === data);
      var obj = {
        id: dt.id,
        title: getRestaurantDisplayName(dt),
      };
      tempData.push(obj);
    });

    dataRows.map((dt, index) => {
      var obj = {
        id: dt.id,
        title: getRestaurantDisplayName(dt),
      };
      allTempData.push(obj);
    });
    setAllRestaurantDetails(allTempData);
    console.log("tempData: " + tempData[0].title);
    setClickedRestaurantDetails(tempData);
  };
  const handleAddopenCancelReasonDialog = (AddItemData) => {
    setopenCancelReasonDialog(AddItemData);
    loadData();
  };

  const [loading, setloading] = React.useState(false);

  const [dataLoaded, setdataLoaded] = React.useState(false);

  React.useEffect(() => {
    loadData();
  }, []);

  const approvedData = async (props) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <h1>Are you sure?</h1>
            <p>You want to approve this?</p>
            <button onClick={onClose} className="btn-no btn-common">
              No
            </button>
            <button
              className="btn-yes btn-common"
              onClick={() => {
                // this.handleClickDelete();
                approve(props);
                onClose();
              }}
            >
              Yes
            </button>
          </div>
        );
      },
    });
  };

  const activeLinkData = async (props, text) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <h1>Are you sure?</h1>
            <p>{text}</p>
            <button onClick={onClose} className="btn-no btn-common">
              No
            </button>
            <button
              className="btn-yes btn-common"
              onClick={() => {
                // this.handleClickDelete();
                approve(props);
                onClose();
              }}
            >
              Yes
            </button>
          </div>
        );
      },
    });
  };

  const approve = async (props) => {
    const token = localStorage.getItem("gotasteadmintoken");

    if (token) {
    } else {
      window.location.href = "/login";
    }
    setloading(true);
    SetloadingModal(true);
    axios({
      method: "put",
      url:
        apiAddress +
        "/api/NewRestaturantRequest/updateRestaurantRequests/" +
        props,
      data: selectedData,
      headers: {
        Authorization: "Bearer " + token,
      },
    })
      .then(function (response) {
        setloading(false);
        SetloadingModal(false);
        console.log(response);
        toast.success("Successfully Saved", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        loadData();
      })
      .catch(function (error) {
        setloading(false);
        SetloadingModal(false);
        console.log(error);
        toast.error("Error" + error, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  const loadData = async () => {
    const token = localStorage.getItem("gotasteadmintoken");

    if (token) {
    } else {
      window.location.href = "/login";
    }
    axios({
      method: "get",
      url: apiAddress + "/api/NewRestaturantRequest",
      headers: {
        Authorization: "Bearer " + token,
      },
    })
      .then(function (response) {
        console.log(response.data);
        setDataRows(response.data);
        var state = false;
        setdataLoaded(state);
      })
      .catch(function (error) { });

    // await axios
    //     .get(apiAddress + "/api/NewRestaturantRequest")
    //     .then((response) => {
    //         setDataRows(response.data);
    //         var state = false;
    //         setdataLoaded(state);
    //     });
  };
  const [loadingModal, SetloadingModal] = React.useState(false);

  const closeLoadingModal = () => {
    SetloadingModal(false);
  };

  const pendingRequests = dataRows?.filter(
    (x) => x?.approvalStatusDescription === "Pending",
  );

  const approvedRequests = dataRows?.filter(
    (x) => x?.approvalStatusDescription === "Approved",
  );

  const linkActivated = dataRows?.filter(
    (x) => x?.approvalStatusDescription === "Link Activated",
  );
  console.log("data rows", dataRows);

  return (
    <div>
      <LoadingView open={loadingModal} close={closeLoadingModal} />
      <ToastContainer />
      {/* <div className=' d-flex justify-content-between' style={{ height: '3.5rem', backgroundColor: '#56595b' }}>
                <div className='' >
                    <div className='d-flex flex-row'>
                        <div>

                            <SideBar />

                        </div>
                        <h4 className='mt-1' style={{ color: 'white', marginLeft: '1rem' }}>Go <span style={{ color: '#e5e5e5', fontWeight: '700' }}>Taste</span></h4>



                    </div>
                </div>
                <div className='d-flex' style={{ marginRight: '1rem', marginTop: '10px', gap: "10px" }}>
                    <h5 style={{ color: 'white', marginRight: '1rem' }}>Welcome, Leo</h5>
                    <img src={Leo} alt='leo' style={{ width: '2rem', height: '2rem' }} />
                    <h5 style={{ color: 'white', marginRight: '1rem', cursor: "pointer" }} onClick={() => {
                        localStorage.removeItem('gotasteadmintoken');
                        window.location.href = `/`;
                    }}>Log Out</h5>
                </div>


            </div> */}
      <TopHeader />
      <div className="p-5">
        <div className="d-flex align-items-center justify-content-center gap-4 m-4 mt-0">
          <div
            className="new_restaurant_request__totalcard px-4"
            style={{
              backgroundColor: "rgba(157, 220, 243, 0.266)",
              color: "#000",
            }}
          >
            <div className="p-5">
              <p className="new_restaurant_request__totalNumber">
                {dataRows?.length}
              </p>
              <p className="totalRequestTitle">All Requests</p>
            </div>
          </div>
          <div
            className="new_restaurant_request__totalcard"
            style={{
              backgroundColor: "rgba(249, 197, 138, 0.302)",
              color: "#000",
            }}
          >
            <div className="p-5">
              <p className="new_restaurant_request__totalNumber">
                {pendingRequests?.length}
              </p>
              <p className="totalRequestTitle">Pending Requests</p>
            </div>
          </div>
          <div
            className="new_restaurant_request__totalcard"
            style={{
              backgroundColor: "rgba(164, 208, 111, 0.364)",
              color: "#000",
            }}
          >
            <div className="p-5">
              <p className="new_restaurant_request__totalNumber">
                {approvedRequests?.length}
              </p>
              <p className="totalRequestTitle">Approved Requests</p>
            </div>
          </div>
          <div
            className="new_restaurant_request__totalcard"
            style={{
              backgroundColor: "rgba(25, 102, 224, 0.76)",
              color: "#fff",
            }}
          >
            <div className="p-5">
              <p className="new_restaurant_request__totalNumber">
                {linkActivated.length}
              </p>
              <p className="totalRequestTitle">Link Activated</p>
            </div>
          </div>
        </div>

        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          mt={2}
          mb={2}
        >
          <Grid item>
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <div
                  className={` ${enableOptions ? "" : "disable"
                    }  roundedCorner`}
                  onClick={() => {
                    approvedData(1);
                  }}
                >
                  <img src={approveImg} alt="" style={{ width: "1rem" }} />{" "}
                  Approve
                </div>
              </Grid>
              <Grid item>
                <div
                  className={` ${enableOptions ? "" : "disable"
                    }  roundedCorner`}
                  onClick={() => {
                    handleClickopenCancelReasonDialog();
                  }}
                >
                  <img src={bin} alt="" style={{ width: "1rem" }} /> Reject
                </div>
              </Grid>
              <Grid item>
                <div
                  className={` ${enableOptions ? "" : "disable"
                    }  roundedCorner`}
                  onClick={() => {
                    activeLinkData(4, "You want to active this?");
                  }}
                >
                  <img src={linkactiveImg} alt="" style={{ width: "1rem" }} />{" "}
                  Activate Link
                </div>
              </Grid>
              <Grid item>
                <div
                  className={` ${enableOptions ? "" : "disable"
                    }  roundedCorner`}
                  onClick={() => {
                    activeLinkData(5, "You want to deactive this?");
                  }}
                >
                  <img src={linkDeactiveImg} alt="" style={{ width: "1rem" }} />{" "}
                  Deactivate Link
                </div>
              </Grid>

              {/* <Grid item>
                                
                                <select className="form-select form-control" aria-label="Default select example">
                                    <option selected>Action</option>
                                    <option value="1">View</option>
                                    <option value="2">Two</option>
                                    <option value="3">Three</option>
                                </select>
                            </Grid> */}
            </Grid>
          </Grid>
          <Grid item>
            <Grid container flexDirection={"column"} alignItems={"center"}>
              <Grid item>
                <img src={searchIcon} alt="" style={{ width: "1rem" }} />
              </Grid>
              <Grid item>Search</Grid>
            </Grid>
          </Grid>
        </Grid>
        {dataRows.length > 0 ? (
          <CustomDataGrid
            columns={columnsdatas}
            dataRows={dataRows}
            getselectedData={getselectedData}
            selectedRows={selectedData}
            isLoading={loading}
          />
        ) : (
          "Nothing found"
        )}
      </div>
      <RestaurantDetailsDialog
        open={open}
        onClose={handleAddItem}
        dialogName={"Add On"}
        restaurantName={clickedRestaurant}
      />
      <CancelReasonDialog
        open={openCancelReasonDialog}
        onClose={handleAddopenCancelReasonDialog}
        dialogName={"Add On"}
        restaurantName={clickedRestaurantDetails}
        allRestaurant={allRestaurantDetails}
        from={1}
      />
    </div>
  );
}

export default NewRestaurantRequest;
